import { Component, Inject, OnInit, Input } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';

import { trackByValue } from 'v2/modules/shared/util/track-by.util';

import { IOrderPickingPreviewDialogInterface } from '../../../order/interfaces/order.interface';
import {
  PicklistPreviewItemInterface,
  PreviewPickingItemInterface,
} from '../../../picklist/interfaces/picklist.interface';

@Component({
  selector: 'lum-picklist-preview-dialog',
  templateUrl: './picklist-preview-dialog.component.html',
  styleUrls: ['./picklist-preview-dialog.component.scss'],
})
export class PicklistPreviewDialogComponent implements OnInit {
  picklistPreviewItems :PicklistPreviewItemInterface[] = [];
  withPicklistErrorIds :number[] = [];
  pickingPreviewData :IOrderPickingPreviewDialogInterface[] = [];
  hideActionButtons :boolean = false;
  salesOrdersWithMoreThanOneShipment :number[] = [];

  trackByValue = trackByValue;

  constructor(
    public dialogRef :MatDialogRef<PicklistPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data :{
      pickingPreviewData :IOrderPickingPreviewDialogInterface[];
      errors :string[];
      hideActionButtons :boolean;
    },
    private router :Router,
  ) {
    this.pickingPreviewData = this.data.pickingPreviewData || [];
    this.hideActionButtons = this.data.hideActionButtons || false;
  }

  ngOnInit() :void {
    if (
      this.pickingPreviewData !== undefined &&
      this.pickingPreviewData.length > 0
    ) {
      this.pickingPreviewData.forEach((item :any) => {
        let pickingItems :PreviewPickingItemInterface[] = [];
        if (item?.pickingItems?.length > 0) {
          pickingItems = item?.pickingItems.filter(
            (pickingItem :PreviewPickingItemInterface) =>
              pickingItem.availableQuantity <= 0,
          );
        }

        if (pickingItems.length > 0 || !item?.fulfillmentStatus) {
          this.withPicklistErrorIds.push(item?.salesOrder?.id);
          this.picklistPreviewItems.push({
            id: item?.salesOrder?.orderId,
            orderDate: item?.salesOrder?.orderDate,
            orderNumber: item?.salesOrder?.orderNumber,
            pickingItems: pickingItems,
            fulfillmentStatus: item?.fulfillmentStatus,
          });
        }
      });
    }

    this.getSalesOrdersWithMoreThanOneShipment();
  }

  private getSalesOrdersWithMoreThanOneShipment() :void {
    this.salesOrdersWithMoreThanOneShipment = this.data.errors?.reduce(
      (acc, message) => {
        const moreThanOneShipmentRegex =
          /Order\(s\) have multiple shipments\. \[(\d+)\]/;
        const withShipmentAndPendingItemsRegex =
          /Order\(s\) have shipments and pending items\. \[(\d+)\]/;

        const moreThanOneShipmentMatch = message.match(moreThanOneShipmentRegex);
        const withShipmentAndPendingItemsMatch = message.match(
          withShipmentAndPendingItemsRegex,
        );

        if (moreThanOneShipmentMatch) {
          acc.push(+moreThanOneShipmentMatch[1]);
        } else if (withShipmentAndPendingItemsMatch) {
          acc.push(+withShipmentAndPendingItemsMatch[1]);
        }

        return acc;
      },
      [] as number[],
    );
  }

  closeDialog() :void {
    this.dialogRef.close(false);
  }

  continueCreatePicklist() :void {
    this.dialogRef.close(this.withPicklistErrorIds);
  }

  onRedirectToSalesOrderPicklist(salesOrderId :number) :void {
    const urlTree = this.router.createUrlTree(['/shipping/picklists'], {
      queryParams: { salesOrderId },
    });
    const url = this.router.serializeUrl(urlTree);
    window.open(url, '_blank');
  }

  get salesOrdersWithExistingPicklists() :number[] {
    return this.data.errors?.reduce((acc, message) => {
      const pickListRegex =
        /Order\(s\) already have existing pick lists\. \[(\d+)\]/;

      const match = message.match(pickListRegex);
      if (match) {
        acc.push(+match[1]);
      }

      return acc;
    }, [] as number[]);
  }
}
